import Immutable from "seamless-immutable";

const initialState = Immutable({});

const NewsReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default NewsReducer;
